import React from 'react';
import { Checkbox, TableCell, TableRow, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { draggableHandleIdentifier, draggableHandleRootClass, draggableRowIdentifier, draggableRowRootClass, IColumnHeader, ISecuritiesTableField } from './SecuritiesTable'
import { format12hourDateTime } from "../../../utilities/utilities";
import DragHandle from './DragHandle';
interface SecuritiesTableRowProps<T> {
	columns: IColumnHeader[],
	row: any,
	index: number,
	draggable?: boolean;
	dragProxyColumn?: string;
	handleSelect?: (id: number, isSelected: boolean) => void;
	selected?: boolean;
	selectedRowColor: string;
}

const renderField = (field: ISecuritiesTableField): any => {

	switch (field.type) {

		case "datetime":
			if (field.value === null) {
				return '';
			}

			return format12hourDateTime(new Date(field.value));

		case "date":
			if (field.value === null) {
				return '';
			}

			let date = new Date(field.value);
			return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`

		case "boolean":
			if (field.value === null) {
				return '';
			}

			return field.value ? <Checkbox checked={true} style={{color: 'rgba(0, 0, 0, 0.6)'}}/> : <Checkbox checked={false} style={{color: 'rgba(0, 0, 0, 0.6)'}}/>;

		default:
			return field.value
	}
}

const createLocalStyles = makeStyles((theme: Theme) =>
	createStyles({
		tablecell: {
			whiteSpace: "pre-wrap",
			wordWrap: "break-word",
			overflowWrap: "break-word"
		},
		namecell: {
			overflowWrap: "break-word",
			whiteSpace: "pre-wrap",
			wordWrap: "break-word"
		},
	}),
);

export default function SecuritiesTableRow<T>({ columns, row, index, draggable = false, dragProxyColumn, handleSelect,
	selected = false, selectedRowColor}: SecuritiesTableRowProps<T>) {
	const classes = createLocalStyles();

	const toggleSelectRow = (e: any) => {
		let checked = e.target.checked;

		if (handleSelect) {
			handleSelect(row.selectId.value, checked);
		}
	};

	return (
		<TableRow id={`row-${index}`} key={index} className={draggableRowRootClass}
			style={selected ? { backgroundColor: selectedRowColor } : undefined}>

			{handleSelect && (
				<TableCell>
					<Checkbox onChange={toggleSelectRow} checked={selected} style={{ color: 'black' }} />
				</TableCell>
			)}

			{draggable && (
				<TableCell
					id={`${draggableHandleIdentifier}${index}`}
					className={draggableHandleRootClass}
					size="small"
					key={-1}
					draggable={true}
				>
					<DragHandle />
				</TableCell>
			)}
			{columns.map((column, idx) => (
				<TableCell id={ column.field === dragProxyColumn ? `proxy-${index}-${dragProxyColumn}` : undefined } size="small" key={idx} className={column.field === "name" ? classes.namecell : classes.tablecell} >
					{renderField(row[column.field])}
				</TableCell>
			))}
		</TableRow>
	)
}